import React from "react";

import { noop } from "lodash";

import { useCompanyFilterFlagOn, useLibraryQueryParams } from "../Filters/Filters";

export const CompanyPanelContext = React.createContext<{
	isPanelVisible: boolean;
	setIsPanelVisible: (isPanelVisible: boolean) => void;
	companyPanelShouldMount: boolean;
}>({
	isPanelVisible: false,
	setIsPanelVisible: noop,
	companyPanelShouldMount: false,
});

export const CompanyPanelContextProvider = ({ children }: { children: React.ReactNode }) => {
	const isCompanyFilterEnabled = useCompanyFilterFlagOn();
	const { companyDomain } = useLibraryQueryParams();

	// companyPanelShouldMount dictates whether the panel should be mounted (loading its data, etc.)
	const companyPanelShouldMount = Boolean(isCompanyFilterEnabled && companyDomain?.value);

	// isPanelVisible dictates whether the panel should be visible.
	// We want to avoid unmounting and re-mounting the panel when the collapse button is clicked,
	// because doing so re-runs the panel's queries, which can be slow/expensive.
	const [isPanelVisible, setIsPanelVisible] = React.useState(companyPanelShouldMount);

	// Update isPanelVisible when companyPanelShouldMount changes
	React.useEffect(() => {
		setIsPanelVisible(companyPanelShouldMount);
	}, [companyPanelShouldMount]);

	const value = React.useMemo(
		() => ({ isPanelVisible, setIsPanelVisible, companyPanelShouldMount }),
		[isPanelVisible, setIsPanelVisible, companyPanelShouldMount],
	);

	return <CompanyPanelContext.Provider value={value}>{children}</CompanyPanelContext.Provider>;
};
